import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const students = [
  { id: '1', name: '小明', region: '北京（城市）', grade: '高三', subjects: ['数学', '物理'], avatar: 'https://public.readdy.ai/ai/img_res/db1b26e1ed89087675bd69198cfa3548.jpg', online: true },
  { id: '2', name: '小花', region: '湖南（农村）', grade: '高二', subjects: ['英语', '语文'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20student%20smiling%20portrait%2C%20simple%20background%2C%20studious%20look&width=80&height=80&seq=s002&orientation=squarish', online: true },
  { id: '3', name: '大壮', region: '四川（农村）', grade: '初三', subjects: ['数学', '化学'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20boy%20student%20portrait%2C%20friendly%20smile%2C%20clean%20background&width=80&height=80&seq=s003&orientation=squarish', online: false },
  { id: '4', name: '晓雪', region: '上海（城市）', grade: '高三', subjects: ['英语', '数学'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20portrait%2C%20bright%20smile%2C%20clean%20background&width=80&height=80&seq=s004&orientation=squarish', online: true },
  { id: '5', name: '阿强', region: '广东（城市）', grade: '大学', subjects: ['考研', '英语'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20university%20male%20student%20portrait%2C%20confident%20smile%2C%20clean%20background&width=80&height=80&seq=s005&orientation=squarish', online: false },
  { id: '6', name: '小燕', region: '云南（农村）', grade: '高一', subjects: ['语文', '历史'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20student%20portrait%2C%20warm%20smile%2C%20simple%20background&width=80&height=80&seq=s006&orientation=squarish', online: true },
];

const messages = [
  { id: '1', from: '小花', content: '你好！我是湖南农村的学生，英语比较弱，你能帮我吗？', time: '10:23', isMine: false },
  { id: '2', from: '我', content: '当然可以！我英语还不错，我们可以互相帮助，你帮我练习方言？', time: '10:25', isMine: true },
  { id: '3', from: '小花', content: '太好了！我们可以每天晚上8点一起学习！', time: '10:26', isMine: false },
  { id: '4', from: '我', content: '好的！我们建个学习计划吧，一起冲刺高考！', time: '10:28', isMine: true },
];

export default function StudentPage() {
  const [addedIds, setAddedIds] = useState<Set<string>>(new Set());
  const [chatOpen, setChatOpen] = useState(false);
  const [chatStudent, setChatStudent] = useState<typeof students[0] | null>(null);
  const [inputMsg, setInputMsg] = useState('');
  const [chatMessages, setChatMessages] = useState(messages);

  const handleAdd = (id: string) => {
    setAddedIds((prev) => { const n = new Set(prev); n.add(id); return n; });
  };

  const openChat = (student: typeof students[0]) => {
    setChatStudent(student);
    setChatOpen(true);
  };

  const sendMessage = () => {
    if (!inputMsg.trim()) return;
    setChatMessages((prev) => [...prev, { id: String(Date.now()), from: '我', content: inputMsg, time: new Date().toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' }), isMine: true }]);
    setInputMsg('');
  };

  return (
    <div className="min-h-screen bg-[#faf9f7]">
      <Navbar />
      <div className="relative pt-20 pb-10 bg-gradient-to-br from-blue-700 to-blue-900">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h1 className="text-3xl md:text-4xl font-black text-white mb-3">学生互助交流</h1>
          <p className="text-white/70 text-sm">城市与农村学生跨越地域，互加好友，共同学习进步</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {students.map((student) => (
            <div key={student.id} className="bg-white rounded-2xl p-5">
              <div className="flex items-start gap-4">
                <div className="relative flex-shrink-0">
                  <img src={student.avatar} alt={student.name} className="w-14 h-14 rounded-full object-cover object-top" />
                  {student.online && (
                    <div className="absolute bottom-0 right-0 w-3.5 h-3.5 bg-green-500 rounded-full border-2 border-white"></div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-900">{student.name}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${student.online ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                      {student.online ? '在线' : '离线'}
                    </span>
                  </div>
                  <p className="text-gray-500 text-xs mt-0.5">{student.region} · {student.grade}</p>
                  <div className="flex flex-wrap gap-1 mt-2">
                    {student.subjects.map((s) => (
                      <span key={s} className="text-xs bg-blue-50 text-blue-600 px-2 py-0.5 rounded-full">{s}</span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex gap-2 mt-4">
                <button
                  onClick={() => handleAdd(student.id)}
                  className={`flex-1 py-2 rounded-full text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
                    addedIds.has(student.id) ? 'bg-green-100 text-green-700' : 'bg-blue-600 text-white hover:bg-blue-700'
                  }`}
                >
                  {addedIds.has(student.id) ? '已添加' : '+ 加好友'}
                </button>
                <button
                  onClick={() => openChat(student)}
                  className="flex-1 py-2 rounded-full text-xs font-semibold border border-blue-200 text-blue-600 hover:bg-blue-50 transition-all cursor-pointer whitespace-nowrap"
                >
                  发消息
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Chat Modal */}
      {chatOpen && chatStudent && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-end sm:items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-md flex flex-col" style={{ height: '520px' }}>
            {/* Chat Header */}
            <div className="flex items-center gap-3 p-4 border-b border-gray-100">
              <img src={chatStudent.avatar} alt={chatStudent.name} className="w-9 h-9 rounded-full object-cover object-top" />
              <div className="flex-1">
                <p className="font-semibold text-gray-900 text-sm">{chatStudent.name}</p>
                <p className="text-xs text-gray-400">{chatStudent.region}</p>
              </div>
              <button onClick={() => setChatOpen(false)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-gray-500"></i>
              </button>
            </div>
            {/* Messages */}
            <div className="flex-1 overflow-y-auto p-4 flex flex-col gap-3">
              {chatMessages.map((msg) => (
                <div key={msg.id} className={`flex ${msg.isMine ? 'justify-end' : 'justify-start'}`}>
                  <div className={`max-w-[75%] px-3.5 py-2.5 rounded-2xl text-sm ${msg.isMine ? 'bg-blue-600 text-white rounded-br-sm' : 'bg-gray-100 text-gray-800 rounded-bl-sm'}`}>
                    {msg.content}
                    <p className={`text-xs mt-1 ${msg.isMine ? 'text-blue-200' : 'text-gray-400'}`}>{msg.time}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* Input */}
            <div className="p-4 border-t border-gray-100 flex gap-2">
              <input
                type="text"
                value={inputMsg}
                onChange={(e) => setInputMsg(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                placeholder="输入消息..."
                className="flex-1 bg-gray-50 rounded-full px-4 py-2 text-sm outline-none"
              />
              <button onClick={sendMessage} className="w-9 h-9 flex items-center justify-center bg-blue-600 text-white rounded-full cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-send-plane-fill text-sm"></i>
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
